import { useContext } from "react";
import { FrameRendererContext } from "./frame-renderer-context";
import { useInlineFrameEmbed } from "./inline-frame-embed-context";

/**
 * True while the frame is an opened item: the body of a focus or desktop
 * floating window, the independent surfaces that draw frame chrome
 * (`frame-window-shell.tsx`). Not a canvas node, a Pinned wall tile
 * (`chrome: "none"`) or an inline copy in a conversation reply. An opened
 * frame wears its card (Part 10) and puts its tools in its window's hover
 * pill instead of drawing them itself.
 */
export function useOpenedFrame(): boolean {
  const renderer = useContext(FrameRendererContext);
  const embedded = useInlineFrameEmbed();
  return (
    renderer.independentSurface === true &&
    renderer.chrome !== "none" &&
    !embedded
  );
}
